export const tableContent = [
  {
    heading: [
      {
        column: "Loan Amount (₹)",
      },
      {
        column: "Current Interest Rate (%)",
      },
      {
        column: "New Interest Rate (%)",
      },
      {
        column: "Tenure (Months)",
      },
      {
        column: "Current EMI (₹)",
      },
      {
        column: "New EMI (₹)",
      },
      {
        column: "Monthly Savings (₹)",
      },
      {
        column: "Total Savings (₹)",
      },
    ],
    rowData: [
      {
        amount: "₹30,00,000",
        interest: "9%",
        newInterest: "7.5%",
        Tenure: "20",
        currentEMI: "₹26,992",
        newEMI: "₹24,879",
        monthlySaving: "₹2,113",
        totalSaving: "₹5,07,120",
      },
      {
        amount: "₹50,00,000",
        interest: "8.5%",
        newInterest: "7%",
        Tenure: "15",
        currentEMI: "₹49,485",
        newEMI: "₹44,936",
        monthlySaving: "₹4,549",
        totalSaving: "₹8,18,820",
      },
      {
        amount: "₹75,00,000",
        interest: "10%",
        newInterest: "8%",
        Tenure: "25",
        currentEMI: "₹65,468",
        newEMI: "₹57,839",
        monthlySaving: "₹7,629",
        totalSaving: "₹22,88,760",
      },
      {
        amount: "₹1,00,00,000",
        interest: "9.5%",
        newInterest: "7.5%",
        Tenure: "30",
        currentEMI: "₹86,241",
        newEMI: "₹69,760",
        monthlySaving: "₹16,481",
        totalSaving: "₹59,33,160",
      },
    ],
  },
];
